export default [
  {
    image: "/images/beer.jpg",
    title: "Predictive Beer Analytics",
    description: `A project that aims to gather, process, and present beer data to determine where in the world
      different beers will be rated highest. <br /> <br />
      Uses a combination of data mining, natural language processing, image color analysis, and web
      development (all in Python) to come to the conclusions presented in the report.`,
    links: [{ href: "https://github.com/jweinstein92/Predictive_Beer_Analytics/", label: "Github" }, { href: "https://github.com/jweinstein92/Predictive_Beer_Analytics/blob/master/docs/PBA_Report.pdf", label: "Report" }],
  },
  {
    image: "/images/fft.jpg",
    title: "Audio Removal",
    description: `A project that aims to remove chunks of an audio file with two provided WAV files, one for the
      original signal and one for the sample. <br /> <br />
      Using C and the Fast Fourier Transform, we were able to determine the instances of a provided
      sample audio file in another provided audio file and remove the sample from the original. This can
      be used to remove the opening theme song of a podcast for example.`,
    links: [{ href: "https://github.com/jweinstein92/Audio-Removal-Using-FFT-", label: "Github" }],
  },
  {
    image: "/images/zen.png",
    title: "CSS Zen Garden",
    description: `A project that aims to demonstrate the power of CSS by providing a structured HTML file and showing
      the many different ways this HTML can be displayed. <br /> <br />
      Using a provided HTML file, I created a CSS file to create a unique experience for the content.
      Utilizing CSS animations and gradient backgrounds, I tried to create a feeling of calmness by
      taking elements of nature and the northern lights.`,
    links: [{ href: "https://jweinstein92.github.io/css-zen-garden/", label: "Demo" }, { href: "https://github.com/jweinstein92/css-zen-garden", label: "Github" }],
  },
];